import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';
import { CloseRounded } from '@/components/Icons/CloseRounded';
import { AnalyticsEvent, useAnalytics } from '@/hooks/useAnalytics';
import { useController } from '@/hooks/useController';
import { useWidgetState } from '@/hooks/useWidgetState';
import { welcomeMessageSelector, themeSelector, widgetAlignmentSelector, } from '@/state/config';
import { isWidgetOpenState, openingMessageState } from '@/state/session';
import styles from './OpeningMessage.module.scss';
export const OpeningMessage = () => {
    const { trackEvent } = useAnalytics();
    const welcomeMessage = useRecoilValue(welcomeMessageSelector);
    const [showOpeningMessage, setShowOpeningMessage] = useRecoilState(openingMessageState);
    const open = useRecoilValue(isWidgetOpenState);
    const theme = useRecoilValue(themeSelector);
    const { closeWidget } = useWidgetState();
    const { notifyOpeningMessageClosed } = useController();
    const widgetAlignment = useRecoilValue(widgetAlignmentSelector);
    useEffect(() => {
        setShowOpeningMessage(!!welcomeMessage);
    }, [setShowOpeningMessage, welcomeMessage]);
    useEffect(() => {
        if (open && showOpeningMessage) {
            setShowOpeningMessage(false);
        }
    }, [open, setShowOpeningMessage, showOpeningMessage]);
    const handleClose = useCallback(() => {
        trackEvent(AnalyticsEvent.CloseOpeningMessageClick);
        setShowOpeningMessage(false);
        closeWidget();
        notifyOpeningMessageClosed();
    }, [
        closeWidget,
        notifyOpeningMessageClosed,
        setShowOpeningMessage,
        trackEvent,
    ]);
    const handleKeyDown = useCallback(async (event) => {
        if (event.key === 'Enter') {
            handleClose();
        }
    }, [handleClose]);
    if (!showOpeningMessage) {
        return null;
    }
    return (_jsxs("div", { className: cn(styles.text, styles[theme], {
            [styles.isPositionLeft]: widgetAlignment === 'left',
        }), children: [_jsx("p", { children: welcomeMessage }), _jsx("span", { role: "button", tabIndex: 0, className: styles.closeBtn, onClick: handleClose, onKeyDown: handleKeyDown, children: _jsx(CloseRounded, {}) })] }));
};
